import React, { Component } from "react";
import "./style/sign.scss";
import Step0 from "./pages/step0-Instructions";
import Layout from "./components/layout";
import { connect } from "react-redux";
import SignatureCanvas from "./components/signatureCanvas";
import { getCurrentWaiver } from "./action-creators/waiverInfo";
import Step4 from "./pages/step4-InstructionalVideo";
import Step5 from "./pages/step5-ViewWaiver";
import {
  NEXT_STEP,
  LAST_STEP,
  SKIP_STEP,
  SKIP_BACK,
  ROLE_SELECTED,
  SET_INVALID,
  SET_VALID,
  MARKETING_INFORMATION_COLLECTED,
  SIGNATURE_COMPLETED,
  NO_STICKY,
  NONE_SELECTED,
  NEXT_SELECTED,
  NEXT_CONFUSED,
  SKIPPED_BACKWARDS,
  PATH
} from "./constants";
import {
  equals,
  filter,
  find,
  isEmpty,
  isNil,
  length,
  propEq,
  gt,
  startsWith,
  drop,
  toLower
} from "ramda";
import AboutSigner from "./components/AboutSigner";
import Marketing from "./components/Marketing";
import BothDrop from "./components/bothDrop";
import { Formik, Field } from "formik";
import Step6 from "./pages/step6-RecordVideo";
import Step7 from "./pages/step7-ReviewVideo";
import {
  requestOpentok,
  handleError,
  startRecording,
  stopRecording
} from "./action-creators/recorder";
import {
  submitSignedWaiver,
  getPathParticipants,
  getCoords
} from "./action-creators/signedWaiver";
import ScrollToTop from "./components/scrollToTop";
import { currentLocale } from "./locale";
import { toast } from "bulma-toast";
import { SubmitNotification } from "./components/modal";
const url = process.env.PUBLIC_URL;
class App extends Component {
  constructor(props) {
    super(props);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.trim = this.trim.bind(this);
    this.state = {
      isValid: this.props.isValid,
      trimmedDataURL: null,
      signature: null,
      values: {},
      open: false,
      signatureRecieved: false,
      stateParticipantData: {
        name: "",
        role: 0,
        birthday: "",
        referenceKey: "",
        id: "",
        optIn: false, //waiver.contactInformation
        phoneNumber: "",
        icePhone: "",
        email: "",
        icePhoneNumber: "",
        signature: "",
        dateCreated: "",
        video: "",
        participants: [
          {
            participantName: "",
            participantBirthday: "",
            referenceKey: ""
          }
        ],
        linkedParticipant: [
          {
            participantName: "",
            participantBirthday: "",
            referenceKey: ""
          }
        ],
        linkedParticipants: [
          {
            participantName: "",
            participantBirthday: "",
            referenceKey: ""
          }
        ],
        signedByName: ""
      }
    };
  }
  componentDidMount() {
    const url = process.env.PUBLIC_URL;
    const n = length(url);
    const pa = window.location.pathname;
    let pn;
    if (process.env.NODE_ENV === "development") {
      pn = pa;
    } else {
      if (startsWith(toLower(url), toLower(pa))) {
        pn = drop(n, pa);
      }
    }
    const parsePath = pn.split("/");

    const id = parsePath[1] || "";
    const refLocation = parsePath[2] || "";
    const remainingPath = parsePath[3] || "";

    this.props.dispatch({
      type: PATH,
      payload: {
        waiverId: id,
        refLocation: refLocation,
        remainingPath: remainingPath
      }
    });
    this.props.getCurrentWaiver(id);
    this.props.getCoords();
  }

  handleNotification = () => {
    this.setState({ open: true });
    this.props.dispatch({ type: NO_STICKY, payload: true });
  };
  handleClose = () => {
    if (this.props.signedWaiver.failed) {
      this.setState({ open: false });
      this.appReset();
    } else {
      this.setState({ open: false });
      this.goBack();
    }
  };
  appReset = () => {
    try {
      const destination = window.location.href;
      window.history.go(destination);
    }
    catch {
      window.location.reload()
    }
  };
  goBack = () => {
    try {
      if (gt(window.history.length, 1)) {
        window.history.back();
      } else {
        this.appReset();
      }
    }
    catch {
      window.location.reload()
    }
  };
  handleRoleChange = value => {
    let stateParticipantData = this.state.stateParticipantData;
    stateParticipantData.role = value;
    this.props.appRoleToAppState(value);
    this.setState({
      stateParticipantData
    });
  };

  handleStateChange = (key, value) => {
    let stateParticipantData = this.state.trimmedDataURL;
    stateParticipantData[key] = value;
    this.setState({ stateParticipantData });
  };

  sigPad = {};

  padData = this.sigPad._sigPad;

  clear = () => {
    this.sigPad.clear();
  };

  trim = () => {
    this.setState({
      signature: this.sigPad.toDataURL("image/svg+xml")
    });
    if (
      this.touched(this.sigPad._sigPad) ||
      this.touchedTwice(this.sigPad._sigPad)
    ) {
      this.props.signatureToAppState(this.state.signature);
      this.props.setValid();
      this.handleNotification();
      this.props.submitSignedWaiver();
    } else if (!this.touched(this.sigPad._sigPad)) {
      this.timer();
      this.sigPad.props.errors.signature = `${
        currentLocale.incompleteSignature
        }`;
      this.clear();
    } else {
      return this.props.signature;
    }
  };

  touched = canvas => !isNil(canvas) && length(canvas._lastPoints) > 2;

  touchedTwice = canvas =>
    !isEmpty(filter(p => length(p.points) > 1, canvas._data));

  handleSignature = () => {
    this.props.signatureToAppState(this.state.trimmedDataURL);
    this.sigPad.clear();
  };

  stepContent = ({ formikProps }) => {
    const activeStep = find(propEq("step", this.props.step))(this.props.steps);
    switch (this.props.step) {
      case 0:
        return (
          <Step0
            requestOpentok={this.props.requestOpentok}
            waiver={this.props.waiver}
            signedWaiver={this.props.signedWaiver}
          />
        );

      case 1:
        return (
          <Marketing
            setValid={this.props.setValid}
            setInvalid={this.props.setInvalid}
            formikProps={formikProps}
            values={formikProps.values}
            stateParticipantData={this.state.stateParticipantData}
            waiver={this.props.waiver}
            signingInfo={this.props.signingInfo}
            signedWaiver={this.props.signedWaiver}
            {...formikProps}
          />
        );
      case 2:
        return (
          <AboutSigner
            onRoleChange={role => this.handleRoleChange(role)}
            stateParticipantData={this.state.stateParticipantData}
            formikProps={formikProps}
            role={formikProps.values.role}
            values={this.props.signedWaiver}
            touched={formikProps.touched}
            errors={formikProps.errors}
            activeStep={activeStep}
            waiver={this.props.waiver}
            signingInfo={this.props.signingInfo}
            step={this.props.step}
            getPathParticipants={this.props.getPathParticipants}
            selected={this.props.selected}
          />
        );
      case 3:
        return (
          <BothDrop
            formikProps={formikProps}
            setValid={this.props.setValid}
            setInvalid={this.props.setInvalid}
            values={formikProps.values}
            name={formikProps.values.name}
            birthday={formikProps.values.birthday}
            participants={formikProps.values.participants}
            signingInfo={this.props.signingInfo}
            stateParticipantData={this.state.stateParticipantData}
            waiver={this.props.waiver}
            getPathParticipants={this.props.getPathParticipants}
            linkedPath={this.props.linkedPath}
          />
        );
      case 4:
        return (
          <Step4
            formikProps={formikProps}
            activeStep={activeStep}
            waiver={this.props.waiver}
            action={this.validationHandler}
            values={formikProps.values}
          />
        );
      case 5:
        return (
          <Step5
            waiver={this.props.waiver}
            signingInfo={this.props.signingInfo}
            getCurrentWaiver={this.props.getCurrentWaiver}
            skippedBackwards={this.props.skippedBackwards}
          />
        );
      case 6:
        return (
          <Step5
            minorPage={true}
            waiver={this.props.waiver}
            signingInfo={this.props.signingInfo}
            getCurrentWaiver={this.props.getCurrentWaiver}
            skippedBackwards={this.props.skippedBackwards}
          />
        );
      case 7:
        return (
          <Step6
            currentStep={this.props.step}
            signingInfo={this.props.signingInfo}
            waiver={this.props.waiver}
            formikProps={formikProps}
            values={formikProps.values}
            setValid={this.props.setValid}
            setInvalid={this.props.setInvalid}
            recording={this.props.recording}
            opentok={this.props.opentok}
            handleError={this.props.handleError}
            requestOpentok={this.props.requestOpentok}
            startRecording={this.props.startRecording}
            stopRecording={this.props.stopRecording}
            pathParticipants={this.props.pathParticipants}
            handleReset={this.appReset}
            linkedPath={this.props.linkedPath}
          />
        );

      case 8:
        return (
          <div>
            <Step7 formikProps={formikProps} values={formikProps.values} />
          </div>
        );
      case 9:
        return (
          <div className="signature-pad-canvas-container">
            {/*this is handle the submit modals*/}
            <SubmitNotification
              open={this.state.open}
              handleClose={this.handleClose}
              inform={this.props.signedWaiver.submitting}
              failed={this.props.signedWaiver.failed}
              success={this.props.signedWaiver.succeeded}
            />
            <h1 className="title ">{currentLocale.step8Heading}</h1>

            <div className="signature-pad-canvas">
              <SignatureCanvas
                {...formikProps}
                penColor="darkblue"
                canvasProps={{
                  className: "canvas" //"signature-pad-canvas"
                }}
                backgroundColor="rgba(255,255,255,0.5)" //rgba(102, 127, 153, 0.3)" //light gray => white: "rgba(255,255,255,.9)"
                ref={ref => {
                  this.sigPad = ref;
                }}
              />
              <button
                type="button"
                className="signature-pad-canvas-clear-button button is-info"
                onClick={this.clear}
              >
                {currentLocale.clear}
              </button>
            </div>
          </div>
        );
    }
  };

  timerStop = () => {
    toast({
      message: `${currentLocale.incompleteSignature}`,
      type: "is-warning", //"is-danger",
      pauseOnHover: true,
      duration: 3000,
      position: "top-center"
    });
  };

  timer = () => {
    setTimeout(this.timerStop, 200);
  };

  render() {
    const activeStep = find(propEq("step", this.props.step))(this.props.steps);
    return (
      <ScrollToTop step={activeStep}>
        <div className="has-background-light container is-widescreen box">
          <Formik
            initialValues={this.state.stateParticipantData}
            onSubmit={(values, { resetForm, setFieldValue }) => {
              this.trim(values);
            }}
            render={formikProps => (
              <div>
                <Field
                  name="layout"
                  value={this.props.isValid}
                  component={Layout}
                  steps={this.props.steps}
                  waiver={this.props.waiver}
                  currentStep={this.props.step}
                  skipForward={this.props.skipForward}
                  stepForward={this.props.stepForward}
                  submitWaiver={this.props.submitWaiver}
                  validStep={this.props.validStep}
                  validBackStep={this.props.validBackStep}
                  isValid={this.props.isValid}
                  skipBack={this.props.skipBack}
                  stepPrevious={this.props.stepPrevious}
                  setValid={this.props.setValid}
                  setInvalid={this.props.setInvalid}
                  notValid={this.notValid}
                  formikProps={formikProps}
                  onRoleChange={this.props.onRoleChange}
                  values={formikProps.values}
                  errors={formikProps.errors}
                  touched={formikProps.touched}
                  role={formikProps.values.role}
                  signingInfo={this.props.signingInfo}
                  stateParticipantData={this.state.stateParticipantData}
                  dispatch={this.props.dispatch}
                  recording={this.props.recording}
                  requesting={this.props.requesting}
                  opentok={this.props.opentok}
                  locationData={this.props.locationData}
                  pathParticipants={this.props.pathParticipants}
                  noSticky={this.props.noSticky}
                  loading={this.props.signedWaiver.submitting}
                  selected={this.props.selected}
                  noneSelected={this.props.noneSelected}
                  nextSelected={this.props.nextSelected}
                  flashing={equals(false, this.props.selected)} //{true}
                  nextConfused={this.props.nextConfused}
                >
                  {this.stepContent({ formikProps })}
                </Field>
              </div>
            )}
          />
        </div>
      </ScrollToTop>
    );
  }
}

const mapStateToProps = state => ({
  validStep: state.validStep,
  validBackStep: state.validBackStep,
  step: state.stepper.currentStep,
  waiver: state.currentWaiver,
  steps: state.stepper.steps,
  signingInfo: state.signingInfo,
  isValid: state.validStep.isValid,
  signedWaiver: state.signedWaiver,
  recording: state.recording,
  formikProps: state.formikProps,
  opentok: state.opentok.data,
  requesting: state.opentok.requesting,
  signature: state.signingInfo.signature,
  locationData: state.locationData,
  pathParticipants: state.pathParticipants,
  noSticky: state.stepper.noSticky,
  selected: state.signingInfo.selected,
  linkedPath: state.pathParticipants.linkedPath
});

const mapActionToProps = dispatch => ({
  getCurrentWaiver: waiverId => dispatch(getCurrentWaiver(waiverId)),
  stepForward: () => dispatch({ type: NEXT_STEP }),
  skipForward: () => dispatch({ type: SKIP_STEP }),
  skipBack: () => dispatch({ type: SKIP_BACK }),
  skippedBackwards: () => dispatch({ type: SKIPPED_BACKWARDS }),
  stepPrevious: () => dispatch({ type: LAST_STEP }),
  noneSelected: () => dispatch({ type: NONE_SELECTED }),
  nextSelected: () => dispatch({ type: NEXT_SELECTED }),
  nextConfused: () => dispatch({ type: NEXT_CONFUSED }),
  requestOpentok: () => dispatch(requestOpentok()),
  onRoleChange: value => {
    dispatch({ type: ROLE_SELECTED, payload: value });
  },
  signatureToAppState: value => {
    dispatch({ type: SIGNATURE_COMPLETED, payload: value });
  },
  onMarketingChange: value => {
    dispatch({
      type: MARKETING_INFORMATION_COLLECTED,
      payload: {
        optIn: value.optIn,
        icePhone: value.icePhone,
        email: value.email,
        phoneNumber: value.phoneNumber
      }
    });
  },
  setInvalid: () => {
    dispatch({ type: SET_INVALID, payload: false });
  },
  setValid: () => {
    dispatch({ type: SET_VALID, payload: true });
  },
  appRoleToAppState: value => {
    dispatch({ type: ROLE_SELECTED, payload: value });
    dispatch({ type: SET_VALID, payload: true });
  },
  marketingToAppState: (key, value) => {
    dispatch({
      type: MARKETING_INFORMATION_COLLECTED,
      payload: { [key]: value }
    });
  },
  submitSignedWaiver: () => {
    dispatch(submitSignedWaiver());
  },
  handleError: error => dispatch(handleError(error)),
  startRecording: sessionId => dispatch(startRecording(sessionId)),
  stopRecording: () => dispatch(stopRecording()),
  getPathParticipants: () => dispatch(getPathParticipants()),
  getCoords: () => dispatch(getCoords()),
  dispatch
});

const connector = connect(
  mapStateToProps,
  mapActionToProps
);

export default connector(App);
